import styled from 'styled-components'

const ROW_HEIGHT = 62

// Virtuoso measures items, so the gap between rows is a padding — margins are not included in the measurement
export const Row = styled('div')`
  padding-bottom: 8px;
`

// keeps the slot of the dragged row (it leaves the flow while dragging), Virtuoso can't handle zero-sized items
export const Item = styled('div')`
  min-height: ${ROW_HEIGHT}px;
`
